import { render, staticRenderFns } from "./TicketList.vue?vue&type=template&id=58487eba&scoped=true&"
import script from "./TicketList.vue?vue&type=script&lang=js&"
export * from "./TicketList.vue?vue&type=script&lang=js&"
import style0 from "./TicketList.vue?vue&type=style&index=0&id=58487eba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58487eba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VDataTable,VProgressCircular})
